/* عالم سمسم – منتج مكمّل ذكي داخل سلة المشتريات
   بيختار المكمّل من: طلبات حقيقية اتطلبت مع بعض + نفس خط العطر + تشابه الريحة + النوع + الجنس + الماركة + السعر */
(function () {
  if (window.SMSMFBT) return;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var LAST = 'smsm-fbt-last', SKIP = 'smsm-fbt-skip', PC = 'smsm-fbt-pool:';
  var mem = {};

  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) { var v = Math.round(c / 100); return EN ? 'EGP ' + v.toLocaleString('en-US') : v.toLocaleString('en-US') + ' ج.م'; }
  function getJSON(u) {
    if (mem[u]) return mem[u];
    mem[u] = fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    return mem[u];
  }
  /* منتجات القسم (بتتخزن 20 دقيقة) */
  function pool(c) {
    try { var o = JSON.parse(ss(PC + c) || 'null'); if (o && Date.now() - o.t < 12e5) return Promise.resolve(o.ps); } catch (e) {}
    return getJSON(ROOT + 'collections/' + c + '?view=smsmfbt').then(function (d) {
      var ps = (d && d.ps) || []; try { ss(PC + c, JSON.stringify({ t: Date.now(), ps: ps })); } catch (e) {} return ps;
    });
  }

  /* ===== فهم المنتج ===== */
  function kind(p) {
    var t = ((p.t || p.title || '') + ' ' + (p.h || p.handle || '')).toLowerCase();
    var s = t + ' ' + String(p.ty || p.product_type || '').toLowerCase();
    if (/صبغة|hair colou?r|شامبو|بلسم|ماسك (ال)?شعر|زيت .*شعر|hair oil|جدايل/.test(t)) return 'care';
    if (/للمنزل|air freshener|معطر جو|diffuser|فواحة|جهاز تعطير/.test(t)) return 'home';
    if (/مجموعة|بوكس|باقة|gift set|\bset\b|\bbox\b|bundle|collection/.test(t)) return 'set';
    if (/مبخرة|مباخر|burner|mabakher/.test(t)) return 'burner';
    if (/معطر (ال)?شعر|معطر (ال)?جسم|للشعر والجسم|سبراي (ال)?جسم|مخمرية|hair mist|body mist|body spray|hair & body|hair and body|hair-amp-body|\bmist\b|hair perfume|عطر (ال)?شعر|للشعر/.test(t)) return 'mist';
    if (/^\s*(عطر|perfume)|eau de|\bedp\b|\bedt\b|parfum/.test(t)) return 'perfume';
    if (/بخور|معمول|bakhoor|bukhoor|bakhour|incense|oud chips|كسر عود/.test(t)) return 'bakhoor';
    if (/زيت|دهن|خلطة|\boil\b/.test(t)) return 'oil';
    if (/مسك|musk|misk|mesk/.test(t)) return 'musk';
    if (/بودرة|بادور|powder/.test(t)) return 'powder';
    if (/عطر|perfume|parfum|عطور/.test(s)) return 'perfume';
    if (/بخور|bakhoor/.test(s)) return 'bakhoor';
    return 'other';
  }
  function gender(p) {
    var z = String(p.z || '').split('|'); if (z[1] === 'm' || z[1] === 'f' || z[1] === 'u') return z[1];
    var t = String(p.t || p.title || '') + ' ' + String(p.h || p.handle || '');
    if (/للجنسين|unisex/i.test(t)) return 'u';
    if (/للرجال|رجالي|for-men|\bmen\b|homme|for him/i.test(t)) return 'm';
    if (/للنساء|نسائي|for-women|women|femme|for her|\bher\b/i.test(t)) return 'f';
    return 'u';
  }
  var STOP = /^(عطر|معطر|عطور|الشعر|للشعر|شعر|الجسم|والجسم|للجسم|جسم|سبراي|مجموعة|بوكس|من|مل|جم|جرام|للرجال|للنساء|للجنسين|رجالي|نسائي|المركز|مركز|أو|دو|بارفان|بارفيوم|إكستريت|اكستريت|الإصدار|المحدود|زيت|عطري|خالٍ|خال|الكحول|مسك|بخور|معمول|مخمرية|ليميتد|إديشن|الفاخر|فاخر|كلاسيك|classic|perfume|parfum|eau|de|edp|hair|body|mist|and|amp|for|men|women|unisex|by|the|ml|set|box|oil)$/i;
  function stem(p, vendor) {
    var bad = {}; String(vendor || '').toLowerCase().split(/[\s\-–|]+/).forEach(function (w) { if (w) bad[w] = 1; });
    var out = {};
    String(p.t || '').toLowerCase().replace(/[|–\-–()+×,.:/]/g, ' ').split(/\s+/).forEach(function (w) {
      w = w.replace(/^(ال|و)(?=..{2,})/, function (m) { return m; });
      if (w.length < 3 || /\d/.test(w) || STOP.test(w) || bad[w]) return; out[w] = 1;
    });
    return out;
  }
  function sameLine(a, b, vendor) {
    if (!a.b || a.b !== b.b) return false;
    var x = stem(a, vendor), y = stem(b, vendor), n = 0;
    for (var k in x) if (y[k]) n++;
    return n >= 1;
  }
  var FAM = EN ? ['Floral', 'Fruity', 'Citrus', 'Woody', 'Oriental', 'Sweet', 'Spicy', 'Musky'] : ['الزهرية', 'الفاكهية', 'الحمضية', 'الخشبية', 'الشرقية', 'الحلوة', 'الحارّة', 'المسكية'];
  function fam(p) { var z = String(p.z || '').split('|'); if (!z[5]) return null; var v = z[5].split('.').map(Number); return v.length === 8 ? v : null; }
  function notes(p) { var z = String(p.z || '').split('|'); return z[6] ? z[6].split(',') : []; }
  function cos(a, b) { var d = 0, x = 0, y = 0; for (var i = 0; i < 8; i++) { d += a[i] * b[i]; x += a[i] * a[i]; y += b[i] * b[i]; } return x && y ? d / Math.sqrt(x * y) : 0; }
  function topShared(a, b) { var best = -1, bi = -1; for (var i = 0; i < 8; i++) { var m = Math.min(a[i], b[i]); if (m > best) { best = m; bi = i; } } return bi; }

  /* لكل نوع: الأنواع اللي بتكمّله + الأقسام اللي ندوّر فيها */
  var PLAN = {
    perfume: { want: ['mist', 'musk', 'oil', 'bakhoor'], cols: ['hair-and-body-perfumes', 'mesk', 'oils-perfumes'] },
    set: { want: ['mist', 'musk', 'oil', 'bakhoor'], cols: ['hair-and-body-perfumes', 'mesk'] },
    mist: { want: ['perfume', 'musk'], cols: ['best-sellers'] },
    musk: { want: ['perfume', 'mist'], cols: ['best-sellers', 'hair-and-body-perfumes'] },
    oil: { want: ['perfume', 'musk', 'mist'], cols: ['best-sellers', 'mesk'] },
    powder: { want: ['perfume', 'mist', 'musk'], cols: ['best-sellers', 'hair-and-body-perfumes'] },
    bakhoor: { want: ['burner', 'bakhoor', 'home'], cols: ['mabakher', 'bukhor'] },
    burner: { want: ['bakhoor'], cols: ['bukhor'] },
    home: { want: ['bakhoor', 'home'], cols: ['bukhor'] },
    care: { want: ['care'], cols: [] },
    other: { want: [], cols: [] }
  };
  var WHY = EN ? {
    mist: 'A hair & body mist layers over your perfume and keeps it noticeable all day.',
    musk: 'A touch of musk under your perfume makes it softer and longer-lasting.',
    oil: 'A concentrated oil layered with your perfume adds depth and lasts for hours.',
    bakhoor: 'Bakhoor for your home and clothes completes the same scent mood.',
    burner: 'An elegant burner to enjoy your bakhoor the right way.',
    perfume: 'Pair it with a perfume and your scent becomes a full signature.',
    home: 'Complete the scent of your home.',
    care: 'Goes perfectly with what you picked.',
    other: 'Goes perfectly with what you picked.'
  } : {
    mist: 'معطّر الشعر والجسم بيتطبّق فوق عطرك ويطوّل ثباته ويخلّي ريحتك واضحة طول اليوم.',
    musk: 'لمسة مسك على الجسم تحت العطر بتنعّمه وبتطوّل ثباته.',
    oil: 'زيت عطري مركّز مع عطرك بيدّي عمق وثبات لساعات.',
    bakhoor: 'بخور للبيت والهدوم بيكمّل نفس الإحساس العطري.',
    burner: 'مبخرة أنيقة تستمتع بيها ببخورك صح.',
    perfume: 'مع عطر يكمّله ريحتك هتبقى بصمة كاملة.',
    home: 'كمّل ريحة بيتك بنفس الذوق.',
    care: 'بيكمّل اللي اخترته.',
    other: 'بيكمّل اللي اخترته.'
  };
  function times(n) { if (EN) return n + ' times'; if (n === 2) return 'مرتين'; if (n <= 10) return n + ' مرات'; return n + ' مرة'; }

  /* ===== الاختيار ===== */
  function pick(item, cart) {
    var handle = item.handle;
    return getJSON(ROOT + 'products/' + encodeURIComponent(handle) + '?view=smsmfbt').then(function (d) {
      if (!d || !d.m) return null;
      var m = d.m, mk = kind(m), plan = PLAN[mk] || PLAN.other, mg = gender(m), mf = fam(m), mn = notes(m);
      m.p = item.final_price || item.price || m.p;
      var inCart = {}; (cart.items || []).forEach(function (it) { inCart[it.product_id] = 1; });
      var reals = {}; (d.fb || []).forEach(function (f) { if (f && f.x) { f.x.n = f.n; reals[f.x.id] = f.x; } });
      return Promise.all(plan.cols.map(pool)).then(function (lists) {
        var seen = {}, cands = [];
        function add(x, pos, src) {
          if (!x || !x.id || seen[x.id] || x.id === m.id || inCart[x.id] || !x.a || !x.v) return;
          seen[x.id] = 1; x.pos = pos; x.src = src; cands.push(x);
        }
        Object.keys(reals).forEach(function (k) { add(reals[k], 0, 'real'); });
        lists.forEach(function (ps, li) { (ps || []).forEach(function (x, i) { add(x, i, plan.cols[li]); }); });
        var best = null;
        cands.forEach(function (c) {
          var ck = kind(c), real = reals[c.id] ? reals[c.id].n : 0, line = sameLine(m, c, m.b), w = plan.want.indexOf(ck), s = 0;
          if (!real) {
            if (w === -1) return;                               /* لازم يكون مكمّل مش بديل */
            if (ck === mk && line) return;                      /* نفس العطر بحجم تاني = بديل */
          }
          var cg = gender(c);
          if ((mg === 'm' && cg === 'f') || (mg === 'f' && cg === 'm')) { if (!real) return; s -= 6; }
          else if (mg !== 'u' && cg === mg) s += 2;
          if (w > -1) s += (plan.want.length - w) * 3;
          if (real) s += 14 + Math.min(real, 6) * 2;            /* اتطلبوا مع بعض فعلًا */
          if (line) s += 9;                                     /* نفس خط العطر */
          if (c.b && c.b === m.b) s += 5;                       /* نفس الماركة */
          var sim = 0, cf = fam(c);
          if (mf && cf) { sim = cos(mf, cf); s += sim * 8; }
          var cn = notes(c), shared = 0; mn.forEach(function (n) { if (cn.indexOf(n) > -1) shared++; }); s += Math.min(shared, 3);
          if (m.p) { var r = c.p / m.p; if (r >= 0.08 && r <= 0.75) s += 4; else if (r <= 1) s += 1; else s -= 5; }
          s -= Math.min(c.pos, 30) * 0.06;                     /* ترتيب القسم */
          c.score = s; c.kind = ck; c.real = real; c.line = line; c.sim = sim; c.shared = mf && cf ? topShared(mf, cf) : -1;
          if (!best || s > best.score) best = c;
        });
        if (best) best.main = m;
        return best;
      });
    });
  }
  function reason(c) {
    var k = c.kind;
    if (c.real >= 2) return EN ? 'Smsm customers ordered these two together ' + times(c.real) + '.' : 'عملاء عالم سمسم طلبوا الاتنين مع بعض ' + times(c.real) + '.';
    if (c.line && k === 'mist') return EN ? 'The same scent made for hair & body – it locks your perfume in and keeps it going all day.' : 'نفس ريحة عطرك بس للشعر والجسم، بيثبّت الريحة ويطوّلها طول اليوم.';
    if (c.line) return EN ? 'From the same scent line – the same mood in a form that completes it.' : 'من نفس خط العطر، نفس الإحساس بشكل تاني بيكمّله.';
    if (c.sim >= 0.7 && c.shared > -1 && (k === 'mist' || k === 'musk' || k === 'oil'))
      return EN ? 'Shares your perfume\'s ' + FAM[c.shared] + ' character, so it layers without clashing and lasts longer.' : 'ريحته من نفس العائلة ' + FAM[c.shared] + ' زي عطرك، فبيتطبّق معاه من غير ما يتعارض ويطوّل ثباته.';
    return WHY[k] || WHY.other;
  }

  /* ===== الشكل ===== */
  function css() {
    if (document.getElementById('smsm-fbt-css')) return;
    var s = document.createElement('style'); s.id = 'smsm-fbt-css';
    s.textContent = '' +
      '.smsm-fbt{position:relative;margin:0 0 18px;border-radius:18px;padding:14px 14px 12px;background:radial-gradient(120% 140% at 100% 0%,#6A3FA6 0%,#512E83 45%,#2B1748 100%);color:#fff;overflow:hidden;font-family:inherit;box-shadow:0 14px 30px -18px rgba(43,23,72,.8);animation:smsmFbtIn .5s cubic-bezier(.2,.8,.2,1) both}' +
      '.smsm-fbt::after{content:"";position:absolute;width:220px;height:220px;border-radius:50%;border:1px solid rgba(212,175,55,.25);inset-inline-start:-90px;bottom:-140px;pointer-events:none}' +
      '@keyframes smsmFbtIn{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:none}}' +
      '.smsm-fbt__top{display:flex;align-items:center;justify-content:space-between;gap:8px;margin-bottom:10px;position:relative;z-index:1}' +
      '.smsm-fbt__tags{display:flex;flex-wrap:wrap;gap:6px}' +
      '.smsm-fbt__badge{display:inline-flex;align-items:center;gap:5px;background:rgba(212,175,55,.18);border:1px solid rgba(212,175,55,.4);color:#F3E3A6;font-size:11.5px;font-weight:800;padding:3px 10px;border-radius:999px}' +
      '.smsm-fbt__match{display:inline-flex;align-items:center;gap:4px;background:rgba(255,255,255,.1);border:1px solid rgba(255,255,255,.18);color:#fff;font-size:11px;font-weight:800;padding:3px 9px;border-radius:999px}' +
      '.smsm-fbt__x{background:none;border:0;color:rgba(255,255,255,.6);font-size:18px;line-height:1;cursor:pointer;padding:2px 4px}' +
      '.smsm-fbt__h{font-size:16px;font-weight:800;margin:0 0 4px;line-height:1.4;color:#fff;position:relative;z-index:1}' +
      '.smsm-fbt__why{font-size:12.5px;line-height:1.7;color:rgba(255,255,255,.82);margin:0 0 12px;position:relative;z-index:1}' +
      '.smsm-fbt__pair{display:flex;align-items:center;gap:8px;position:relative;z-index:1}' +
      '.smsm-fbt__img{width:64px;height:64px;flex:0 0 64px;border-radius:14px;background:#fff;padding:5px;box-shadow:0 8px 18px -10px rgba(0,0,0,.6);display:block}' +
      '.smsm-fbt__img img{width:100%;height:100%;object-fit:contain;border-radius:10px;display:block}' +
      '.smsm-fbt__plus{width:24px;height:24px;flex:0 0 24px;border-radius:50%;background:#D4AF37;color:#1E1530;font-weight:900;display:flex;align-items:center;justify-content:center;font-size:16px;line-height:1}' +
      '.smsm-fbt__info{flex:1;min-width:0}' +
      '.smsm-fbt__t{font-size:13px;font-weight:800;color:#fff!important;line-height:1.45;text-decoration:none;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}' +
      '.smsm-fbt__p{display:block;font-size:13px;font-weight:800;color:#F3E3A6;margin-top:2px}' +
      '.smsm-fbt__foot{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-top:12px;padding-top:10px;border-top:1px solid rgba(255,255,255,.14);position:relative;z-index:1}' +
      '.smsm-fbt__sum{font-size:12px;color:rgba(255,255,255,.75);line-height:1.4}' +
      '.smsm-fbt__sum b{display:block;font-size:15px;color:#fff}' +
      '.smsm-fbt__add{border:0;border-radius:12px;min-height:42px;padding:0 16px;font-weight:800;font-size:13.5px;cursor:pointer;color:#1E1530;background:linear-gradient(180deg,#E2C35A 0%,#D4AF37 55%,#BF9A26 100%);box-shadow:0 8px 18px -8px rgba(212,175,55,.7);white-space:nowrap;font-family:inherit}' +
      '.smsm-fbt__add[disabled]{opacity:.75;cursor:default}' +
      '.smsm-fbt.is-done .smsm-fbt__add{background:#fff;color:#2B1748}';
    document.head.appendChild(s);
  }
  function img(u) { return u ? '<img src="' + esc(u) + (String(u).indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" loading="lazy">' : ''; }

  var busy = false;
  function card(item, c) {
    var m = c.main, total = (item.final_price || item.price || m.p || 0) + c.p;
    var mainImg = item.featured_image ? (item.featured_image.url || item.featured_image) : (item.image || m.i);
    var badge = c.real >= 2 ? (EN ? '✦ Often bought together' : '✦ بيتطلبوا مع بعض') : c.line ? (EN ? '✦ Same scent line' : '✦ من نفس الخط') : (EN ? '✦ Perfect match' : '✦ يكمّل اختيارك');
    var match = c.sim > 0 ? Math.round(55 + c.sim * 44) : 0;
    var el = document.createElement('div'); el.className = 'smsm-fbt'; el.dir = EN ? 'ltr' : 'rtl'; el.setAttribute('data-smsm-fbt', c.id);
    el.innerHTML =
      '<div class="smsm-fbt__top"><span class="smsm-fbt__tags"><span class="smsm-fbt__badge">' + badge + '</span>' +
      (match >= 70 ? '<span class="smsm-fbt__match">' + (EN ? 'Scent match ' : 'توافق الريحة ') + match + '%</span>' : '') + '</span>' +
      '<button type="button" class="smsm-fbt__x" aria-label="' + (EN ? 'Hide' : 'إخفاء') + '">×</button></div>' +
      '<p class="smsm-fbt__h">' + (EN ? 'Complete your scent ritual' : 'كمّل تجربتك العطرية') + '</p>' +
      '<p class="smsm-fbt__why">' + esc(reason(c)) + '</p>' +
      '<div class="smsm-fbt__pair">' +
        '<span class="smsm-fbt__img">' + img(mainImg) + '</span>' +
        '<span class="smsm-fbt__plus" aria-hidden="true">+</span>' +
        '<a class="smsm-fbt__img" href="' + ROOT + 'products/' + encodeURIComponent(c.h) + '">' + img(c.i) + '</a>' +
        '<span class="smsm-fbt__info"><a class="smsm-fbt__t" href="' + ROOT + 'products/' + encodeURIComponent(c.h) + '">' + esc(c.t) + '</a><span class="smsm-fbt__p">' + money(c.p) + '</span></span>' +
      '</div>' +
      '<div class="smsm-fbt__foot"><span class="smsm-fbt__sum">' + (EN ? 'Both together' : 'الاتنين مع بعض') + '<b>' + money(total) + '</b></span>' +
      '<button type="button" class="smsm-fbt__add" data-vid="' + c.v + '">' + (EN ? 'Add to order' : 'أضفه للطلب') + '</button></div>';
    el.querySelector('.smsm-fbt__x').addEventListener('click', function () { ss(SKIP, String(item.product_id)); el.remove(); });
    el.querySelector('.smsm-fbt__add').addEventListener('click', function (e) { addIt(e.currentTarget, el); });
    return el;
  }

  function refreshDrawer(sections) {
    var cn = document.querySelector('cart-notification');
    var html = sections && sections['minicart-form'], target = document.getElementById('minicart-form');
    if (html && target) {
      var src = new DOMParser().parseFromString(html, 'text/html').querySelector('#minicart-form');
      if (src) target.innerHTML = src.innerHTML;
    }
    if (cn && typeof cn.cartAction === 'function') { try { cn.cartAction(); } catch (e) {} }
    fetch(ROOT + 'cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = el.classList.contains('cart-count-drawer') ? '(' + cart.item_count + ')' : cart.item_count; });
      try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart })); } catch (e) {}
    }).catch(function () {});
  }
  function addIt(btn, el) {
    if (btn.disabled) return; btn.disabled = true; btn.textContent = EN ? 'Adding…' : 'بنضيفه…';
    busy = true;
    fetch(ROOT + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.vid), quantity: 1 }], sections: 'minicart-form' })
    }).then(function (r) { return r.json(); }).then(function (res) {
      busy = false;
      if (res && res.status && res.status >= 400) throw new Error(res.description || 'error');
      el.classList.add('is-done'); btn.textContent = EN ? 'Added ✓' : 'اتضاف ✓';
      ss(SKIP, ss(LAST));
      setTimeout(function () { refreshDrawer(res.sections); }, 650);
    }).catch(function () { busy = false; btn.disabled = false; btn.textContent = EN ? 'Try again' : 'حاول تاني'; });
  }

  /* ===== العرض جوه السلة ===== */
  var renderTimer, token = 0;
  function show() {
    clearTimeout(renderTimer);
    renderTimer = setTimeout(function () {
      var body = document.querySelector('#minicart-form .minicart-body');
      if (!body || busy) return;
      var last = ss(LAST); if (!last) return;
      if (ss(SKIP) === last) { var o = body.querySelector('.smsm-fbt'); if (o) o.remove(); return; }
      var my = ++token;
      fetch(ROOT + 'cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return;
        var item = null; cart.items.forEach(function (it) { if (String(it.product_id) === last) item = item || it; });
        if (!item) return;
        return pick(item, cart).then(function (c) {
          if (my !== token) return;
          var b = document.querySelector('#minicart-form .minicart-body'); if (!b) return;
          var old = b.querySelector('.smsm-fbt');
          if (!c) { if (old) old.remove(); return; }
          if (old && old.getAttribute('data-smsm-fbt') === String(c.id)) return;
          css(); var el = card(item, c);
          if (old) old.replaceWith(el); else b.insertBefore(el, b.firstChild);
        });
      }).catch(function () {});
    }, 180);
  }

  /* نعرف إن العميل ضاف منتج (أي طريقة إضافة في الثيم) */
  function noteAdd(data) {
    try {
      var it = data && (data.items ? data.items[0] : data);
      if (it && it.product_id) { ss(LAST, String(it.product_id)); if (ss(SKIP) !== String(it.product_id)) ss(SKIP, null); setTimeout(show, 400); setTimeout(show, 1400); }
    } catch (e) {}
  }
  var _fetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = _fetch.apply(this, arguments);
    if (/\/cart\/add(\.js)?(\?|$)/.test(url) && !busy) p.then(function (r) { if (r && r.ok) r.clone().json().then(noteAdd).catch(function () {}); }).catch(function () {});
    return p;
  };
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    if (/\/cart\/add(\.js)?(\?|$)/.test(String(u))) this.addEventListener('load', function () { try { if (this.status < 400) noteAdd(JSON.parse(this.responseText)); } catch (e) {} });
    return _open.apply(this, arguments);
  };

  function watch() {
    var f = document.getElementById('minicart-form');
    if (!f || !('MutationObserver' in window)) return;
    new MutationObserver(function () { if (!f.querySelector('.smsm-fbt')) show(); }).observe(f, { childList: true });
    show();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  window.SMSMFBT = { show: show, pick: pick, kind: kind, reason: reason };
})();
